<template>
  <v-container fluid class="pa-0">
    <!-- Header -->
    <div class="mb-6">
      <div
        style="
          font-size: 28px;
          font-weight: 800;
          color: #111827;
          letter-spacing: -0.5px;
        "
      >
        Student Matching and Endorsement
      </div>
      <div style="font-size: 14px; color: #6b7280" class="mt-1">
        Manage student placements and HTE endorsements
      </div>
    </div>

    <!-- Metric Cards -->
    <v-row class="mb-4" style="gap: 0">
      <v-col cols="3">
        <div
          class="metric-card"
          style="background: #fffbeb; border-color: #fde68a"
        >
          <div class="d-flex justify-space-between align-start mb-3">
            <div class="metric-icon" style="background: #fef3c7">
              <v-icon color="#d97706" size="20">mdi-clock-outline</v-icon>
            </div>
            <v-icon color="#d97706" size="18">mdi-trending-up</v-icon>
          </div>
          <div class="metric-number" style="color: #d97706">
            {{ getForEndorsement }}
          </div>
          <div class="metric-label" style="color: #92400e">For Endorsement</div>
          <div class="metric-sub">Awaiting job matching</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div
          class="metric-card"
          style="background: #f5f3ff; border-color: #ddd6fe"
        >
          <div class="d-flex justify-space-between align-start mb-3">
            <div class="metric-icon" style="background: #ede9fe">
              <v-icon color="#7c3aed" size="20"
                >mdi-send-variant-outline</v-icon
              >
            </div>
            <v-icon color="#7c3aed" size="18">mdi-trending-up</v-icon>
          </div>
          <div class="metric-number" style="color: #7c3aed">
            {{ getEndorsed }}
          </div>
          <div class="metric-label" style="color: #5b21b6">Endorsed</div>
          <div class="metric-sub">Pending HTE acceptance</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div
          class="metric-card"
          style="background: #f0fdf4; border-color: #bbf7d0"
        >
          <div class="d-flex justify-space-between align-start mb-3">
            <div class="metric-icon" style="background: #dcfce7">
              <v-icon color="#16a34a" size="20"
                >mdi-account-check-outline</v-icon
              >
            </div>
            <v-icon color="#16a34a" size="18">mdi-check-circle-outline</v-icon>
          </div>
          <div class="metric-number" style="color: #16a34a">
            {{ getDeployed }}
          </div>
          <div class="metric-label" style="color: #15803d">Deployed</div>
          <div class="metric-sub">Currently in training</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div
          class="metric-card"
          style="background: #f0fdf4; border-color: #bbf7d0"
        >
          <div class="d-flex justify-space-between align-start mb-3">
            <div class="metric-icon" style="background: #dcfce7">
              <v-icon color="#16a34a" size="20"
                >mdi-account-multiple-outline</v-icon
              >
            </div>
            <v-icon color="#16a34a" size="18">mdi-trending-up</v-icon>
          </div>
          <div class="metric-number" style="color: #16a34a">
            {{ getForTransfer }}
          </div>
          <div class="metric-label" style="color: #15803d">Total Students</div>
          <div class="metric-sub">In current filter</div>
        </div>
      </v-col>
    </v-row>

    <!-- Filter Bar -->
    <div
      class="mb-4 px-4 py-3 rounded-xl d-flex align-center justify-space-between"
      style="
        background: #fff;
        border: 1px solid #e5e7eb;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
      "
    >
      <div class="d-flex align-center" style="gap: 12px">
        <div class="d-flex align-center" style="gap: 6px">
          <v-icon color="#9ca3af" size="18">mdi-filter-outline</v-icon>
          <span style="font-size: 13px; color: #6b7280; font-weight: 500"
            >Filters:</span
          >
        </div>
        <span style="font-size: 13px; color: #374151; font-weight: 500"
          >Program</span
        >
        <div style="width: 180px">
          <v-autocomplete
            density="compact"
            v-model="programs"
            item-value="id"
            item-title="name"
            :color="$vuetify.theme.themes.light.inputColor"
            variant="outlined"
            hide-details
            @update:modelValue="loadStudentsForMatching"
            :items="programsList"
          />
        </div>
        <span style="font-size: 13px; color: #374151; font-weight: 500"
          >Batch</span
        >
        <div style="width: 180px">
          <v-autocomplete
            density="compact"
            v-model="batch"
            item-value="id"
            item-title="name"
            @update:modelValue="loadStudentsForMatching"
            :color="$vuetify.theme.themes.light.inputColor"
            variant="outlined"
            hide-details
            :items="batchList"
          />
        </div>
      </div>
      <div style="font-size: 13px; color: #6b7280">
        Showing
        <strong style="color: #111827">{{ getStudentList.length }}</strong> of
        <strong style="color: #111827">{{ class_data_list.length }}</strong>
        students
      </div>
    </div>

    <!-- Tabs -->
    <v-tabs v-model="activeTab" color="#10B981" align-tabs="left" class="mb-4">
      <v-tab
        v-for="tab in tabList"
        :value="tab.name"
        :key="tab.id"
        @click="changeTab(tab)"
        style="text-transform: none; font-weight: 600; font-size: 14px"
      >
        <v-icon size="16" class="mr-1">{{ tab.icon }}</v-icon>
        {{ tab.name }}
        <v-chip
          v-if="tab.id == 1"
          size="x-small"
          color="#10B981"
          class="ml-2 text-white"
          >{{ getStudentList.length }}</v-chip
        >
        <v-chip
          v-if="tab.id != 1"
          size="x-small"
          color="#10B981"
          class="ml-2 text-white"
          >{{ data.length }}</v-chip
        >
      </v-tab>
    </v-tabs>

    <!-- Tab 1: For Matching -->
    <div v-if="tab == 1">
      <div
        class="rounded-xl"
        style="
          display: flex;
          height: 560px;
          border: 1px solid #e5e7eb;
          overflow: hidden;
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
        "
      >
        <!-- Student List Panel -->
        <div
          style="
            width: 320px;
            flex-shrink: 0;
            border-right: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            background: #fff;
          "
        >
          <div class="pa-3">
            <v-text-field
              v-model="search"
              placeholder="Search students..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :color="$vuetify.theme.themes.light.inputColor"
              style="border-radius: 10px"
            />
          </div>
          <div style="flex: 1; overflow-y: auto">
            <div v-if="getStudentList.length > 0">
              <div
                v-for="i in getStudentList"
                :key="i.id"
                @click="selectStudent(i)"
                class="student-list-item"
                :class="i.isSelected ? 'student-list-item--active' : ''"
              >
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <div class="student-name">
                      {{ toTitleCase(i.fname + " " + i.lname) }}
                    </div>
                    <div class="student-meta">
                      {{ i.program.abbr }}
                    </div>
                  </div>
                  <div
                    class="status-dot"
                    :style="
                      i.isSelected ? 'background:#10B981' : 'background:#f59e0b'
                    "
                  />
                </div>
              </div>
            </div>
            <div v-else class="pa-4 text-center">
              <v-icon size="32" color="#d1d5db">mdi-account-off-outline</v-icon>
              <div style="font-size: 13px; color: #9ca3af; margin-top: 6px">
                <i>No student found.</i>
              </div>
            </div>
          </div>
        </div>

        <!-- HTE Panel -->
        <div
          style="
            flex: 1;
            display: flex;
            flex-direction: column;
            background: #fafafa;
            overflow: hidden;
          "
        >
          <div
            v-if="studentData"
            style="
              display: flex;
              flex-direction: column;
              height: 100%;
              overflow: hidden;
            "
          >
            <!-- Student Info Header -->
            <div
              class="pa-4"
              style="background: #fff; border-bottom: 1px solid #e5e7eb"
            >
              <div style="font-size: 18px; font-weight: 700; color: #111827">
                {{ toTitleCase(studentData.fname + " " + studentData.lname) }}
              </div>
              <div style="font-size: 12px; color: #6b7280" class="mb-2">
                {{ studentData.program.abbr }}
              </div>
              <div
                class="d-flex flex-wrap"
                style="gap: 6px"
                v-if="studentData.profiling"
              >
                <div
                  v-for="(item, idx) in studentData.profiling.skills"
                  :key="idx"
                  class="skill-chip"
                >
                  {{ item }}
                </div>
              </div>
            </div>

            <!-- Recommended HTEs -->
            <div class="pa-3 d-flex align-center" style="gap: 6px">
              <v-icon color="#10B981" size="16">mdi-star-outline</v-icon>
              <span style="font-size: 13px; font-weight: 600; color: #374151"
                >Recommended HTEs</span
              >
            </div>

            <div
              style="
                flex: 1;
                overflow-y: auto;
                padding: 0 12px 12px;
                min-height: 0;
              "
            >
              <div v-if="!hteLoading">
                <div
                  v-for="(item, idx) in hte_results"
                  :key="item.id"
                  class="hte-card"
                  :class="idx == 0 ? 'hte-card--top' : ''"
                >
                  <div class="d-flex justify-space-between align-start">
                    <div class="d-flex align-center" style="gap: 8px">
                      <div class="hte-icon">
                        <v-icon size="16" color="#6b7280">mdi-domain</v-icon>
                      </div>
                      <div
                        style="
                          font-size: 14px;
                          font-weight: 600;
                          color: #111827;
                        "
                      >
                        {{ item.internship.company }}
                      </div>
                    </div>
                    <div class="text-right">
                      <div
                        style="font-size: 14px; font-weight: 700"
                        :style="idx == 0 ? 'color:#d97706' : 'color:#64748b'"
                      >
                        {{ item.matchPercentage }}% Match
                      </div>
                      <div style="font-size: 11px; color: #9ca3af">
                        Slots:
                        <strong>{{ item.internship.slotsAvailable }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <div
                      style="
                        font-size: 10px;
                        text-transform: uppercase;
                        color: #9ca3af;
                        font-weight: 600;
                        letter-spacing: 0.5px;
                      "
                    >
                      Skill Match
                    </div>
                    <div class="mt-1 d-flex flex-wrap" style="gap: 4px">
                      <v-chip
                        size="x-small"
                        color="green"
                        v-for="s in item.matchedSkills"
                        :key="s"
                        >{{ s }}</v-chip
                      >
                    </div>
                  </div>
                  <div class="mt-3 d-flex justify-end">
                    <v-btn
                      :color="$vuetify.theme.themes.light.submitBtnsGreen"
                      @click="endorseStudent(item)"
                      density="comfortable"
                      variant="flat"
                      size="small"
                      rounded="lg"
                    >
                      Endorse Student <v-icon size="16">mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div
                v-if="hteLoading"
                class="d-flex justify-center align-center"
                style="height: 200px"
              >
                <v-progress-circular
                  :size="60"
                  :width="6"
                  color="green"
                  indeterminate
                />
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div
            v-if="!studentData"
            class="d-flex flex-column justify-center align-center"
            style="height: 100%; gap: 12px"
          >
            <div
              style="
                width: 72px;
                height: 72px;
                border-radius: 50%;
                background: #f3f4f6;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <v-icon size="36" color="#d1d5db">mdi-account-outline</v-icon>
            </div>
            <div style="font-size: 16px; font-weight: 700; color: #111827">
              Select a student to view matches
            </div>
            <div
              style="
                font-size: 13px;
                color: #9ca3af;
                max-width: 280px;
                text-align: center;
              "
            >
              Click on any student from the list to see recommended job
              opportunities based on their skill set.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 2/3/4: Data Table -->
    <div v-if="tab != 1">
      <div
        class="rounded-xl"
        style="
          border: 1px solid #e5e7eb;
          overflow: hidden;
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
        "
      >
        <div
          class="pa-4 d-flex justify-space-between align-center"
          style="background: #fff; border-bottom: 1px solid #e5e7eb"
        >
          <div>
            <div style="font-size: 16px; font-weight: 700; color: #111827">
              {{ getTabTitle }}
            </div>
            <div style="font-size: 13px; color: #6b7280">{{ getSubtitle }}</div>
          </div>
          <div style="width: 280px">
            <v-text-field
              v-model="search"
              placeholder="Search..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :color="$vuetify.theme.themes.light.inputColor"
            />
          </div>
        </div>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :loading="table_loading"
          hover
          density="comfortable"
          class="rounded-b-xl"
        >
          <template v-slot:[`item.fname`]="{ item }">
            <div class="py-2 font-weight-medium">
              {{ toTitleCase(item.fname + " " + item.lname) }}
            </div>
          </template>
          <template v-slot:[`item.organization.name`]="{ item }">
            <div class="py-2">{{ item.organization.name }}</div>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <div>
              {{
                formatDate(
                  tab == 2
                    ? item.organization_pulled_out_date
                    : tab == 3
                    ? item.organization_endorsed_date
                    : item.organization_deployed_date,
                )
              }}
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" style="gap: 6px">
              <v-btn
                v-if="tab == 2 || tab == 4"
                color="light-blue"
                class="white--text"
                @click="tab == 2 ? view_pullout(item) : view_deployment(item)"
                density="comfortable"
                variant="flat"
                size="small"
                rounded="lg"
              >
                View <v-icon size="14">mdi-eye</v-icon>
              </v-btn>
              <v-btn
                v-if="tab == 2 || tab == 3"
                :color="$vuetify.theme.themes.light.submitBtnsGreen"
                class="white--text"
                @click="tab == 2 ? assign_hte(item) : deploy_to_hte(item)"
                density="comfortable"
                variant="flat"
                size="small"
                rounded="lg"
              >
                {{ tab == 2 ? "Reassign HTE" : "Deploy" }}
                <v-icon size="14">mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn
                v-if="tab == 4"
                color="red"
                class="white--text"
                @click="pullout(item)"
                density="comfortable"
                variant="flat"
                size="small"
                rounded="lg"
              >
                Pullout <v-icon size="14">mdi-undo</v-icon>
              </v-btn>
            </div>
          </template>
          <template #no-data>
            <div class="text-caption pa-4"><i>No data found.</i></div>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- ── All your existing dialogs unchanged ── -->
    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1"
          >Are you sure you want to delete this item?</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="endorseStudentConfirmation" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Endorse Student</v-card-title>
        <v-card-text class="text-body-1"
          >Are you sure you want to endorse this student to this
          organization?</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="endorseStudentConfirmation = false"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="btnLoading"
            :loading="btnLoading"
            :color="$vuetify.theme.themes.light.submitBtnsGreen"
            class="white--text"
            @click="saveEndorsement"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deployStudentConfirmation" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Deploy Student</v-card-title>
        <v-card-text class="text-body-1"
          >Are you sure you want to deploy this student to this
          organization?</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="deployStudentConfirmation = false"
            >Cancel</v-btn
          >
          <v-btn
            :disabled="btnLoading"
            :loading="btnLoading"
            :color="$vuetify.theme.themes.light.submitBtnsGreen"
            class="white--text"
            @click="saveDeployment"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deploymentDetailsDialog" max-width="800">
      <v-card class="rounded-lg">
        <v-card-title
          class="d-flex align-center pa-4"
          style="
            background: linear-gradient(
              to bottom,
              rgba(16, 185, 129, 0.1),
              rgba(16, 185, 129, 0.05)
            );
          "
        >
          <div>
            <div class="text-h6 font-weight-bold text-uppercase">
              {{ deploymentDetails.fname + " " + deploymentDetails.lname }}
            </div>
            <div class="text-grey text-caption">
              Student internship Overview
            </div>
          </div>
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="deploymentDetailsDialog = false"
          />
        </v-card-title>
        <v-card-text>
          <div class="d-flex ga-2">
            <div style="width: 80%" class="border border-1 rounded-lg pa-2">
              <div class="d-flex ga-2 align-center">
                <v-icon color="#10B981">mdi-account-outline</v-icon>
                <div class="text-subtitle-1 font-weight-bold">
                  Student Information
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Fullname</div>
                <div class="text-caption font-weight-bold text-uppercase">
                  {{ deploymentDetails.fname + " " + deploymentDetails.lname }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Program & section</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.program.abbr }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Sex</div>
                <div class="text-caption font-weight-bold text-uppercase">
                  {{ deploymentDetails.sex }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Student ID</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.school_id }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Skills</div>
                <div
                  class="d-flex flex-wrap ga-1"
                  v-if="deploymentDetails.profiling"
                >
                  <v-chip
                    size="x-small"
                    color="green"
                    v-for="i in deploymentDetails.profiling.skills"
                    :key="i"
                    >{{ i }}</v-chip
                  >
                </div>
              </div>
            </div>
            <div style="width: 80%" class="border border-1 rounded-lg pa-2">
              <div class="d-flex ga-2 align-center">
                <v-icon color="#10B981">mdi-domain</v-icon>
                <div class="text-subtitle-1 font-weight-bold">
                  Host Training Establishment
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Company Name</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.organization.name }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Location</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.organization.address }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Supervisor</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.organization.contact_person }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Company Email</div>
                <div class="text-caption font-weight-bold">
                  {{ deploymentDetails.organization.email }}
                </div>
              </div>
              <div class="mt-2 ml-1">
                <div class="text-overline text-grey">Deployment Date</div>
                <div class="text-caption font-weight-bold">
                  {{ formatDate(deploymentDetails.organization_deployed_date) }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-4 pa-2 rounded-lg border border-1"
            style="
              background: linear-gradient(
                to bottom,
                rgba(16, 185, 129, 0.1),
                rgba(16, 185, 129, 0.05)
              );
            "
          >
            <div class="d-flex ga-2 align-center">
              <v-icon color="#10B981">mdi-clock-outline</v-icon>
              <div class="text-subtitle-1 font-weight-bold">
                Training Hours Progress
              </div>
            </div>
            <div class="mt-2 d-flex ga-2 justify-space-between">
              <div class="box1 bg-white pa-2 rounded-lg">
                <div class="text-overline text-grey">Total required</div>
                <div class="text-h5 mt-n2 font-weight-bold">
                  {{ deploymentDetails.program.ojt_hours }}
                </div>
                <div class="text-caption text-grey">hours</div>
              </div>
              <div class="box1 bg-white pa-2 rounded-lg">
                <div class="text-overline text-grey">Completed</div>
                <div class="text-h5 mt-n2 font-weight-bold text-green">
                  {{ deploymentDetails.completed_ojt_hours }}
                </div>
                <div class="text-caption text-grey">hours</div>
              </div>
              <div class="box1 bg-white pa-2 rounded-lg">
                <div class="text-overline text-grey">Remaining</div>
                <div class="text-h5 mt-n2 font-weight-bold text-red">
                  {{ deploymentDetails.remaining_ojt_hours }}
                </div>
                <div class="text-caption text-grey">hours</div>
              </div>
            </div>
            <div class="mt-4">
              <div class="text-caption d-flex justify-space-between">
                <div>Overall Progress</div>
                <div class="text-green">
                  {{ deploymentDetails.completion_percentage }}%
                </div>
              </div>
              <v-progress-linear
                class="rounded-lg"
                :color="$vuetify.theme.themes.light.inputColor"
                height="10"
                :model-value="deploymentDetails.completion_percentage"
              />
            </div>
          </div>
          <div
            class="mt-4 pa-2 rounded-lg border border-1"
            style="
              background: linear-gradient(
                to bottom,
                rgba(16, 185, 129, 0.1),
                rgba(16, 185, 129, 0.05)
              );
            "
          >
            <div class="d-flex ga-2 align-center">
              <v-icon color="#10B981">mdi-license</v-icon>
              <div class="text-subtitle-1 font-weight-bold">
                Expected Completion
              </div>
            </div>
            <div class="mt-2">
              <div
                class="bg-white pa-2 rounded-lg d-flex justify-space-between align-center"
              >
                <div>
                  <div class="text-overline text-grey">
                    Target Completion Date
                  </div>
                  <div class="text-h6 mt-n2 font-weight-bold">
                    {{ formatDate(deploymentDetails.estimated_end_date) }}
                  </div>
                </div>
                <div
                  class="pa-2 d-flex align-center justify-center"
                  style="
                    border-radius: 100%;
                    width: 50px;
                    height: 50px;
                    border: 1px solid #10b9811a;
                    background-color: #10b9811a;
                  "
                >
                  <v-icon color="#10B981">mdi-calendar</v-icon>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            color="red"
            @click="deploymentDetailsDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pulloutReasonDialog" max-width="500">
      <v-form ref="PullOutRef">
        <v-card>
          <v-card-title class="text-h6">Pullout Reason Details</v-card-title>
          <v-card-text class="text-body-1">
            <v-textarea
              cols="12"
              rows="5"
              :rules="pulloutAction == 'Pullout' ? [formRules.required] : []"
              v-model="pulloutReason"
              variant="outlined"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              variant="text"
              color="red"
              @click="pulloutReasonDialog = false"
              >close</v-btn
            >
            <v-btn
              v-if="pulloutAction == 'Pullout'"
              :disabled="btnLoading"
              :loading="btnLoading"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              density="compact"
              @click="savePullout"
              variant="elevated"
              >Pullout</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- <v-dialog v-model="reassignHTEDialog" max-width="900">
      <v-form ref="ReassignHTERef">
        <v-card>
          <v-card-title class="text-h6">Reassign HTE</v-card-title>
          <v-card-text class="text-body-1">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  density="compact"
                  v-model="reassignSelectedHte"
                  item-value="id"
                  item-title="name"
                  label="Select HTE"
                  @update:modelValue="loadSelectedHTE"
                  :color="$vuetify.theme.themes.light.inputColor"
                  variant="outlined"
                  :items="hteList"
                />
              </v-col>
              <v-col cols="6">
                <div class="pa-2 rounded-lg border border-1">
                  <div class="text-h6">HTE Details</div>
                  <div class="mt-2">
                    <div class="text-overline text-grey">Company Name</div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ hteData && hteData.name }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="text-overline text-grey">Company Address</div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ hteData && hteData.address }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="text-overline text-grey">Preferred Skill</div>
                    <div class="d-flex ga-1 flex-wrap">
                      <v-chip
                        size="x-small"
                        color="green"
                        v-for="i in hteData && hteData.prefered_skills"
                        :key="i"
                        >{{ i }}</v-chip
                      >
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="text-overline text-grey">
                      Preferred Work Arrangement
                    </div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ hteData && hteData.preferred_training_mode }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" color="red" @click="reassignHTEDialog = false"
              >close</v-btn
            >
            <v-btn
              :disabled="btnLoading"
              :loading="btnLoading"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              density="compact"
              @click="saveReassignment"
              variant="elevated"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog> -->
    <v-dialog v-model="reassignHTEDialog" max-width="700">
      <v-form ref="ReassignHTERef">
        <v-card class="rounded-xl" style="overflow: hidden">
          <!-- Header -->
          <div
            class="px-6 py-4 d-flex align-center justify-space-between"
            style="
              background: linear-gradient(to right, #f0fdf4, #dcfce7);
              border-bottom: 1px solid #bbf7d0;
            "
          >
            <div class="d-flex align-center" style="gap: 10px">
              <div
                style="
                  width: 38px;
                  height: 38px;
                  border-radius: 10px;
                  background: #10b981;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon color="white" size="20">mdi-domain</v-icon>
              </div>
              <div>
                <div style="font-size: 16px; font-weight: 700; color: #111827">
                  Reassign HTE
                </div>
                <div style="font-size: 12px; color: #6b7280">
                  Select a new Host Training Establishment
                </div>
              </div>
            </div>
            <v-btn
              icon="mdi-close"
              variant="text"
              size="small"
              @click="reassignHTEDialog = false"
            />
          </div>

          <v-card-text class="pa-6">
            <v-row>
              <!-- Left: Select HTE -->
              <v-col cols="5">
                <div
                  class="pa-4 rounded-xl h-100"
                  style="background: #f9fafb; border: 1px solid #e5e7eb"
                >
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 600;
                      color: #6b7280;
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                    "
                    class="mb-3"
                  >
                    Select Organization
                  </div>
                  <v-autocomplete
                    density="compact"
                    v-model="reassignSelectedHte"
                    item-value="id"
                    item-title="name"
                    label="Search HTE..."
                    @update:modelValue="loadSelectedHTE"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    :items="hteList"
                    style="background: white; border-radius: 10px"
                  />
                  <div
                    v-if="!hteData"
                    class="mt-4 d-flex flex-column align-center justify-center text-center"
                    style="gap: 8px; padding: 24px 0"
                  >
                    <v-icon size="40" color="#d1d5db"
                      >mdi-office-building-outline</v-icon
                    >
                    <div style="font-size: 12px; color: #9ca3af">
                      Select an HTE to view its details
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- Right: HTE Details -->
              <v-col cols="7">
                <div
                  class="pa-4 rounded-xl h-100"
                  style="border: 1px solid #e5e7eb; background: #fff"
                >
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 600;
                      color: #6b7280;
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                    "
                    class="mb-3"
                  >
                    HTE Details
                  </div>

                  <div v-if="hteData">
                    <!-- Company Name -->
                    <div class="detail-row">
                      <div class="detail-icon-wrap" style="background: #f0fdf4">
                        <v-icon size="15" color="#10b981"
                          >mdi-office-building</v-icon
                        >
                      </div>
                      <div>
                        <div class="detail-label">Company Name</div>
                        <div class="detail-value">{{ hteData.name }}</div>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Address -->
                    <div class="detail-row">
                      <div class="detail-icon-wrap" style="background: #eff6ff">
                        <v-icon size="15" color="#3b82f6"
                          >mdi-map-marker-outline</v-icon
                        >
                      </div>
                      <div>
                        <div class="detail-label">Company Address</div>
                        <div class="detail-value">{{ hteData.address }}</div>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Preferred Skills -->
                    <div class="detail-row" style="align-items: flex-start">
                      <div
                        class="detail-icon-wrap"
                        style="background: #fef9c3; margin-top: 2px"
                      >
                        <v-icon size="15" color="#d97706"
                          >mdi-star-outline</v-icon
                        >
                      </div>
                      <div style="flex: 1">
                        <div class="detail-label">Preferred Skills</div>
                        <div
                          v-if="
                            hteData.prefered_skills &&
                            hteData.prefered_skills.length
                          "
                          class="mt-1 d-flex flex-wrap"
                          style="gap: 4px"
                        >
                          <v-chip
                            size="x-small"
                            color="green"
                            v-for="i in hteData.prefered_skills"
                            :key="i"
                            >{{ i }}</v-chip
                          >
                        </div>
                        <div v-else class="detail-value">—</div>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Work Arrangement -->
                    <div class="detail-row">
                      <div class="detail-icon-wrap" style="background: #fdf4ff">
                        <v-icon size="15" color="#9333ea">mdi-laptop</v-icon>
                      </div>
                      <div>
                        <div class="detail-label">Work Arrangement</div>
                        <div class="detail-value">
                          {{ hteData.preferred_training_mode || "—" }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty state -->
                  <div
                    v-else
                    class="d-flex flex-column align-center justify-center text-center"
                    style="height: 200px; gap: 8px"
                  >
                    <v-icon size="48" color="#e5e7eb">mdi-domain</v-icon>
                    <div style="font-size: 13px; color: #d1d5db">
                      No HTE selected
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Footer Actions -->
          <div
            class="px-6 py-4 d-flex justify-end align-center"
            style="
              gap: 10px;
              border-top: 1px solid #f3f4f6;
              background: #fafafa;
            "
          >
            <v-btn
              variant="text"
              color="red"
              @click="reassignHTEDialog = false"
              style="font-weight: 600"
              >Close</v-btn
            >
            <v-btn
              :disabled="btnLoading || !reassignSelectedHte"
              :loading="btnLoading"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              variant="flat"
              rounded="lg"
              @click="saveReassignment"
              style="font-weight: 600; min-width: 100px"
            >
              <v-icon size="16" class="mr-1">mdi-check</v-icon>
              Save
            </v-btn>
          </div>
        </v-card>
      </v-form>
    </v-dialog>
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>
<script>
// import eventBus from "@/eventBus";
export default {
  components: {},

  data: () => ({
    search: "",
    headers: [
      { title: "Student Name", value: "fname", align: "start" },
      { title: "HTE", value: "organization.name", align: "start" },
      { title: "Date", value: "date", align: "center" },
      // { title: "Status", value: "status", align: "center" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    table_loading: false,
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: "For Matching",
    tab: 1,
    tabList: [
      { id: 1, name: "For Matching", icon: "mdi-account" },
      { id: 2, name: "For Transfer", icon: "mdi-domain" },
      { id: 3, name: "Endorsed", icon: "mdi-domain" },
      { id: 4, name: "Deployed", icon: "mdi-domain" },
    ],
    programsList: [],
    programs: null,
    batchList: [],
    batch: null,
    expandTab1: false,
    expandTab2: false,
    expandTab3: false,
    studentData: null,
    studentRequirementIndex: null,
    status_selected: 1,
    deleteData: null,
    itemData: null,
    alerted: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    class_data: null,
    class_data_list: [],
    submission_data: null,
    hte_results: [],
    selectedHte: null,
    hteLoading: false,
    orgToEndorse: null,
    endorseStudentConfirmation: false,
    deployStudentConfirmation: false,
    deploymentDetailsDialog: false,
    deploymentDetails: null,
    pulloutReasonDialog: false,
    pulloutReason: null,
    dataToDeploy: null,
    btnLoading: false,
    metrics: [],
    dataToPullout: null,
    pulloutAction: null,
    reassignHTEDialog: false,
    dataToReassign: null,
    hteList: [],
    hteData: null,
    reassignSelectedHte: null,
  }),
  computed: {
    role() {
      return this.$store.getters.getActiveRole;
    },

    formattedStudents() {
      return this.data.map((student) => ({
        ...student,
        fullName: `${student.fname} ${student.lname}`,
      }));
    },

    getStudentList() {
      let data = this.class_data_list;
      if (this.search) {
        data = data.filter(
          (d) =>
            d.fname?.toLowerCase().includes(this.search) ||
            d.lname?.toLowerCase().includes(this.search),
        );
      }
      return data;
    },
    getTabTitle() {
      return this.activeTab;
    },

    getSubtitle() {
      let text = "";
      if (this.tab == 2) {
        text = "Monitor students who have been pulled out from partners";
      }
      if (this.tab == 3) {
        text = "Monitor students who have been endorsed to partners";
      }
      if (this.tab == 4) {
        text = "Monitor students who have been deployed to partners";
      }
      return text;
    },

    getForEndorsement() {
      let cnt = 0;
      if (this.class_data_list.length > 0) {
        cnt = this.class_data_list.length;
      }
      return cnt;
    },

    getEndorsed() {
      let cnt = 0;
      if (this.metrics.length > 0) {
        cnt = this.metrics[1].count;
      }
      return cnt;
    },
    getDeployed() {
      let cnt = 0;
      if (this.metrics.length > 0) {
        cnt = this.metrics[2].count;
      }
      return cnt;
    },

    getForTransfer() {
      let cnt = 0;
      if (this.metrics.length > 0) {
        cnt = this.metrics[4].count;
      }
      return cnt;
    },
  },
  watch: {
    // role: {
    //   handler(data) {
    //     if (data == 1) {
    //       this.tabList = [
    //         { id: 1, name: "Student/OJT Requirement" },
    //         { id: 2, name: "Daily/Weekly Submission" },
    //       ];
    //     } else {
    //       this.status_selected = 1;
    //       this.tabList = [
    //         { id: 1, name: "Student/OJT Requirement" },
    //         { id: 2, name: "Daily/Weekly Submission" },
    //       ];
    //     }
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    this.getPrograms();
    this.getBatch();
    this.loadMetrics();
    this.loadStudentsForMatching();
    // this.initialize();
    // eventBus.on("closeUploadStudentDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeViewStudentDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeViewClasslistDialog", () => {
    //   this.initialize();
    // });
    // eventBus.on("closeViewSubmissionDialog", () => {
    //   this.initialize();
    //   // this.loadStudentDataUpdate();
    // });
  },

  beforeUnmount() {
    // eventBus.off("closeUploadStudentDialog");
    // eventBus.off("closeViewStudentDialog");
    // eventBus.off("closeViewClasslistDialog");
    // eventBus.off("closeViewSubmissionDialog");
  },

  methods: {
    pagination(data) {
      this.paginationData = data;
    },

    getProgress(item) {
      let submitted = 0;
      for (let index = 0; index < item.requirements.length; index++) {
        if (item.requirements[index].status == 2) {
          submitted++;
        }
      }
      return {
        submitted,
        toSubmit: item.requirements.length,
      };
    },

    getForApprovalCount(item) {
      let submitcount = 0;
      //console.log(item.requirements);
      for (let index = 0; index < item.requirements.length; index++) {
        if (item.requirements[index].status == 1) {
          submitcount++;
        }
      }
      return submitcount;
    },

    getInternStatus(status) {
      let statuses = [
        { id: 1, desc: "Requested" },
        { id: 2, desc: "Endorsed" },
        { id: 3, desc: "Deployed" },
        { id: 4, desc: "Completed" },
        { id: 5, desc: "Pulled Out" },
        { id: 6, desc: "Terminated" },
      ];
      let data = statuses.find((d) => d.id == status);
      // //console.log("data", data);
      return data.desc;
    },

    selectStudent(item) {
      for (let i = 0; i < this.class_data_list.length; i++) {
        this.class_data_list[i].isSelected = false;
      }
      let idx = this.class_data_list.findIndex((d) => d.id == item.id);
      this.studentData = item;
      this.class_data_list[idx].isSelected = true;
      this.loadMatch(item.id);
    },

    loadStudentsForMatching() {
      setTimeout(() => {
        //console.log("asdasd", this.programs, this.batch);
        this.axiosCall(
          "/student/getStudentsByProgramAndBatch?programs=" +
            (this.programs == -1 ? "All" : this.programs) +
            "&batch=" +
            this.batch,
          "GET",
        ).then((res) => {
          if (res) {
            //console.log("classDATA", res.data);
            let data = res.data;
            let newArray = data.map((item) => {
              return {
                ...item,
                isSelected: false,
              };
            });
            this.class_data_list = newArray;
          }
        });
      }, 1000);

      this.loadMetrics();
    },

    loadStudentsMatched() {
      this.table_loading = true;
      setTimeout(() => {
        if (this.tab == 2) {
          this.axiosCall(
            "/student/getStudentsMatchedProgramAndBatch?programs=" +
              (this.programs == -1 ? "All" : this.programs) +
              "&batch=" +
              this.batch +
              "&status=5",
            "GET",
          ).then((res) => {
            if (res) {
              // //console.log("matched classDATA", res.data);
              this.data = res.data;
              this.table_loading = false;
            }
          });
        } else if (this.tab == 3) {
          this.axiosCall(
            "/student/getStudentsMatchedProgramAndBatch?programs=" +
              (this.programs == -1 ? "All" : this.programs) +
              "&batch=" +
              this.batch +
              "&status=2",
            "GET",
          ).then((res) => {
            if (res) {
              // //console.log("matched classDATA", res.data);
              this.data = res.data;
              this.table_loading = false;
            }
          });
        } else if (this.tab == 4) {
          this.axiosCall(
            "/student/getStudentsMatchedProgramAndBatch?programs=" +
              (this.programs == -1 ? "All" : this.programs) +
              "&batch=" +
              this.batch +
              "&status=3",
            "GET",
          ).then((res) => {
            if (res) {
              // //console.log("matched classDATA", res.data);
              this.data = res.data;
              this.table_loading = false;
            }
          });
        }
      }, 1000);

      this.loadMetrics();
    },

    loadMetrics() {
      setTimeout(() => {
        this.axiosCall(
          "/student/getStudentsMatchingMetrics?programs=" +
            (this.programs == -1 ? "All" : this.programs) +
            "&batch=" +
            this.batch,
          "GET",
        ).then((res) => {
          if (res) {
            //console.log("metrics", res.data);
            this.metrics = res.data;
          }
        });
      }, 1000);
    },

    loadSelectedHTE() {
      //console.log("adsad", this.reassignSelectedHte);
      for (let i = 0; i < this.hteList.length; i++) {
        if (this.reassignSelectedHte == this.hteList[i].id) {
          this.hteData = this.hteList[i];
          break;
        }
      }
    },

    changeTab(tab) {
      //   this.expandTab1 = false;
      this.activeTab = tab.name;
      this.tab = tab.id;
      if (tab.id == 1) {
        this.loadStudentsForMatching();
      } else {
        this.loadStudentsMatched();
      }
    },

    endorseStudent(item) {
      this.orgToEndorse = item.internship.id;
      this.endorseStudentConfirmation = true;
    },

    saveEndorsement() {
      this.btnLoading = true;
      let data = {
        orgID: this.orgToEndorse,
        studentID: this.studentData.id,
      };
      this.axiosCall("/student/endorse-student", "PATCH", data).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.btnLoading = false;
          this.endorseStudentConfirmation = false;
          this.studentData = null;

          this.loadStudentsForMatching();
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },

    saveDeployment() {
      this.btnLoading = true;

      this.axiosCall(
        "/student/deploy-student/" + this.dataToDeploy.id,
        "PATCH",
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
          this.btnLoading = false;
          this.deployStudentConfirmation = false;
          this.dataToDeploy = null;
          this.loadStudentsMatched();
        } else {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },

    async savePullout() {
      let validation = await this.$refs.PullOutRef.validate();
      ////console.log(validation);
      if (validation.valid) {
        this.btnLoading = true;
        let data = {
          remarks: this.pulloutReason,
        };
        this.axiosCall(
          "/student/pullout-student/" + this.dataToPullout.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.pulloutReasonDialog = false;
            this.dataToPullout = null;
            this.loadStudentsMatched();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async saveReassignment() {
      let validation = await this.$refs.ReassignHTERef.validate();
      ////console.log(validation);
      if (validation.valid) {
        this.btnLoading = true;
        let data = {
          newOrgID: this.reassignSelectedHte,
        };
        this.axiosCall(
          "/student/reassign-student/" + this.dataToReassign.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.reassignHTEDialog = false;
            this.dataToReassign = null;
            this.loadStudentsMatched();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    assign_hte(data) {
      ////console.log(data);
      this.axiosCall(
        "/organization/getHTEForReassignment/" + data.id,
        "GET",
      ).then((res) => {
        ////console.log(res.data);
        this.hteList = res.data;
        this.dataToReassign = data;
        this.reassignHTEDialog = true;
      });
    },
    deploy_to_hte(data) {
      ////console.log(data);

      this.dataToDeploy = data;
      this.deployStudentConfirmation = true;
    },
    view_deployment(data) {
      this.axiosCall("/student/getDeploymentDetails/" + data.id, "GET").then(
        (res) => {
          console.log(res.data);
          this.deploymentDetails = res.data;
          this.deploymentDetailsDialog = true;
        },
      );
    },

    view_pullout(data) {
      //console.log(data);
      this.pulloutReason = data.pullout_remarks;
      this.pulloutReasonDialog = true;
      this.pulloutAction = "View";
      this.pulloutReasonDialog = true;
    },

    pullout(data) {
      // this.$refs.PullOutRef.reset();
      this.dataToPullout = data;
      this.pulloutReasonDialog = true;
      this.pulloutAction = "Pullout";
    },

    viewItem(item) {
      let activeRole = this.$store.getters.getActiveRole;
      if (activeRole == 1) {
        if (this.tab == 1) {
          this.itemData = item;
        } else {
          this.submission_data = item;
        }
      } else {
        if (this.tab == 1) {
          this.class_data = item;
        } else {
          this.submission_data = item;
        }
      }
      this.action = "View";
    },

    submission(approval) {
      if (this.studentRequirementIndex) {
        this.studentData.requirements[this.studentRequirementIndex].status =
          approval;
        setTimeout(() => {
          this.studentData.requirements[this.studentRequirementIndex].status =
            approval;
        }, 500);
      } else {
        this.loadStudentDailySubmission();
      }
    },

    viewSubmission(item, index) {
      //console.log("ASDA", item, index);
      let data = item.submission;
      Object.assign(data, {
        name: this.studentData.name,
        student_requirement: item.requirement_name,
      });
      this.studentRequirementIndex = index;
      this.submission_data = data;
      this.action = "View";
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },

    getPrograms() {
      this.axiosCall("/program/getProgramsByInstitute", "GET").then((res) => {
        this.programsList = res.data;
        this.programsList.push({ id: -1, name: "All Programs" });
        this.programs = this.programsList[this.programsList.length - 1].id;
      });
    },
    getBatch() {
      this.axiosCall("/program/getProgramsBatchByInstitute", "GET").then(
        (res) => {
          this.batch = res.data.length > 0 ? res.data[0].id : null;
          this.batchList = res.data;
        },
      );
    },

    loadMatch(id) {
      this.hteLoading = true;
      this.axiosCall("/student/match_student/" + id, "GET").then((res) => {
        // //console.log(res.data);

        this.hte_results = res.data;
        this.hteLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.metric-card {
  border: 1px solid;
  border-radius: 16px;
  padding: 20px;
  height: 140px;
  transition: box-shadow 0.2s;
}
.metric-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.metric-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.metric-number {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 2px;
}
.metric-label {
  font-size: 13px;
  font-weight: 600;
}
.metric-sub {
  font-size: 11px;
  color: #9ca3af;
}
.student-list-item {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.15s;
}
.student-list-item:hover {
  background: #f9fafb;
}
.student-list-item--active {
  background: #f0fdf4 !important;
  border-left: 3px solid #10b981;
}
.student-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}
.student-meta {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.skill-chip {
  background: #f3f4f6;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  color: #374151;
}
.hte-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s;
}
.hte-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.hte-card--top {
  border-color: #fde68a;
  background: #fffbeb;
}
.hte-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box1 {
  width: 100%;
  padding-bottom: 5px;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.detail-icon-wrap {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.detail-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
}
.detail-value {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-top: 1px;
}
</style>
